import "../App.css";
import Home from "./Home";
import About from "./About";
import Resume from "./Resume";
import Projects from "./Projects";
import Contact from "./Contact";
import WorkExperience from "./Experience";

export default function Display() {
  return (
    <div className='pl-[25%]    w-screen back text-white  '>
      <Home />
      <About />
      <WorkExperience />
      <Resume />
      <Projects />
      <Contact />
    </div>
  );
}
